// src/classes/class_1764437229410.js

const class_1764437229410 = 
  {
    id: 1764437229410,
    title: "Christmas Baking Online Workshop",
    date: "",
    details: `Make this festive season sweeter with a special Christmas Baking Workshop you can watch anytime, anywhere! Perfect for home bakers, gifting ideas, and anyone who wants to create stunning Christmas treats with ease.
🎅 Menu Includes:
✨ Christmas Plum Cake
✨ Christmas White Cranberry Truffles
✨ White Chocolate Fudge
✨ Pistachio Cranberry Cookies
✨ Cheesecake Cookie Bars
🎁 Exciting Variations:
• Rum & Raisins Truffles
• Christmas White Plum Cake
• Cheesecake Chocolate Cookie Bars
🎥 What You’ll Get:
✔ Pre-recorded videos (learn at your own pace)
✔ Printable recipe booklet
✔ WhatsApp support for guidance
✔ Beginner-friendly, bakery-style results
✔ Perfect for gifting & festive home baking
💰 Fee: ₹799`,
    time: "",
    price: "Rs. 799 /-",
    type: "online",
  }

export default class_1764437229410;
